// extracted by mini-css-extract-plugin
export var footer = "Footerupdate-module--footer--QVHSI";
export var icons = "Footerupdate-module--icons--XdV2b";
export var item = "Footerupdate-module--item--p+1XW";
export var items = "Footerupdate-module--items--qKJkt";
export var list = "Footerupdate-module--list--attcL";
export var privacyOpen = "Footerupdate-module--privacy-open--hCc5C";
export var privacyPopupLink = "Footerupdate-module--privacy-popup-link--0KX3I";